import pro1 from "../assets/pillpartner.jpeg"
import pro2 from "../assets/ferrofetcher.JPG"
import pro3 from "../assets/final_illustration.png"
import pro4 from "../assets/cove-portfolio.png"
import pro5 from "../assets/roastroute3.png"
import pro6 from "../assets/coyote.png"
import pro7 from "../assets/volvo-2.png"
import pro8 from "../assets/pre.png"
import sciCom from "../assets/sci-com.png"
import oh3 from "../assets/oh-3.png"
import oh2 from "../assets/zebra.png"
import oh1 from "../assets/triangle.png"
import gcc from "../assets/gcc.png"
import scinet from "../assets/git.png"
import placeholder from "../assets/placeholder.png"


const ProjectCardData = [
  {
    imgsrc: pro8,
    title: "UX Auto-tagging System",
    text: "Training a YOLOv10M model and system for element detection, isolation and tagging (in progress).",
    view: "https://drive.google.com/file/d/1zsKbu7g6RCj5fWUsO1_O8qeEZCQnRb-9/view?usp=sharing",
    source: "https://drive.google.com/file/d/1OOqw8yhkYWEuQ3b13ceywXHoCLQruIwv/view?usp=sharing"
  },
  {
    imgsrc: pro3,
    title: "CNN Classifier",
    text: "PyTorch-based deep learning model for hurricane intensity forecasting.",
    view: "https://drive.google.com/file/d/1k8KF6Ui9yT2awSPM993zoFm_6jhEKOsA/view",
    source: "https://github.com/macaroonforu/HurriScan"
  }];

const ProjectCardData_2 = [
  {
    imgsrc: pro7,
    title: "Volvo EV CAS and AEBS",
    text: "STM32 based automatic collision avoidance system with emergency mechanical braking.",
    view: "https://drive.google.com/file/d/1vW4Cx1NoIwSa2lXFqVwjrXSCZVeFDbnI/view?usp=sharing",
    source: "https://github.com/charlottepfritz/CAS-AEBS-Prototype-for-Electric-Vehicle"
  },
  {
    imgsrc: pro1,
    title: "Automated Pill Dispenser",
    text: "Keil µVision IDE, STM32uC, Arduino, ESP8266 Wifi Module, Stepper Motor, Programed in C.",
    view: "https://docs.google.com/presentation/d/1RDwtD4b8-Grs9R-lkKW386Tzc2WU7tst5xYdCDOw14k/edit#slide=id.g2c9c86a3db5_0_1103",
    source: "https://github.com/charlottepfritz/PillPartner"
  },
  {
    imgsrc: pro2,
    title: "Magnetic Waste Collector",
    text: "Arduino, H-Bridge motor driver, joystick, pulley, reversible electromagnet (copper wire, screw).",
    view: "https://devpost.com/software/ferrofetcher",
    source: "https://makeuoft-2024.devpost.com/"
  }];

const ProjectCardData_3 = [
  {
    imgsrc: scinet,
    title: "HPC Self-Guided Courses",
    text: "Created 3 self-guided courses for High Performance Computing (HPC) - Intro to Git, Intro to Python, and Intro to HPC. Figma, HTML/CSS, Moodle LMS.",
    view: "https://education.scinet.utoronto.ca/course/view.php?id=1382",
    source: "https://scinethpc.ca/"
  },
  {
    imgsrc: gcc,
    title: "Grey Cat Creative Design Agency",
    text: "Responsive single-page site with form. Graphics designed in Figma. Built with React19 + Tailwind CSS v4 + Framer Motion Animations.",
    view: "https://grey-cat-creative-design-agency.netlify.app",
    source: "https://grey-cat-creative-design-agency.netlify.app"
  },

  {
    imgsrc: pro5,
    title: "Software Development",
    text: "C++ mapping project in team of 3 with APIs, path-finding algorithims (Dijkstra, A*) and GUI (GTK, EZGL).",
    view: "https://docs.google.com/presentation/d/1WbwRZ_VHZbqrfKZDWOCdXnxgztl_t7HXdPtTbcp-oAg/edit?usp=sharing",
    source: "https://github.com/ambroseling/RoastRoute-GIS"
  },
  {
    imgsrc: pro4,
    title: "Front-End Web Design",
    text: "Dynamic and responsive website design for mental health app for pre-teens (HTML, CSS).",
    view: "https://cove-serenity-in-storytime.netlify.app",
    source: "https://github.com/charlottepfritz/COVE-App-Portfolio"
  },

  {
    imgsrc: pro6,
    title: "GIS Research Study",
    text: "ArcGIS community study mapping coyote patterns during pandemic, featured in Canadian Geographic.",
    view: "https://storymaps.arcgis.com/stories/16b2fbddcda64d7c8873f41fdb175c62",
    source: "https://drive.google.com/file/d/1uY42rQksMuvKH6Hzuum48l-Nlz3yM5ne/view?usp=sharing"
  },
];

const ProjectCardData_4 = [
  {
    imgsrc: sciCom,
    title: "Science Communication Worksheets",
    text: "NSERC funded worksheets for knowledge translation. Topics include how to start a podcast, graphical abstract design, and lay writing for targeted audiences. Designed in Figma. ",
    view: "https://brocku.ca/vpmi/",
    source: "https://brocku.ca/vpmi/"
  },
  {
    imgsrc: oh3,
    title: "Data hygiene for dental practices: The top 15 things every dentist needs to know about cybersecurity",
    text: "The 15 tips in this guide offer practical and actionable steps that every dental professional can implement to protect their clinic from cyber threats. Original article for Oral Health Journal.",
    view: "https://www.oralhealthgroup.com/features/data-hygiene-for-dental-practices-the-top-15-things-every-dentist-needs-to-know-about-cybersecurity/",
    source: "https://www.oralhealthgroup.com/features/data-hygiene-for-dental-practices-the-top-15-things-every-dentist-needs-to-know-about-cybersecurity/"
  },
  {
    imgsrc: oh2,
    title: "How Artificial Intelligence Can Help Find the Zebras in Medicine: AI Diagnosis of Behcet’s Disease",
    text: "Describes a case in which an Artificial Intelligence (AI) tool (ChatGPT), an advanced language artificial intelligence model, played a pivotal role in aiding a periodontist in diagnosing a patient with Behcet’s disease. Original article for Oral Health Journal.",
    view: "https://www.oralhealthgroup.com/features/how-artificial-intelligence-can-help-find-the-zebras-in-medicine-ai-diagnosis-of-behcets-disease/",
    source: "https://www.oralhealthgroup.com/features/how-artificial-intelligence-can-help-find-the-zebras-in-medicine-ai-diagnosis-of-behcets-disease/"
  },
  {
    imgsrc: oh1,
    title: "Cybersecurity & Data Protection in Dentistry: A Global Threat",
    text: "Examines the pros and cons of tactical approaches used to mitigate cybersecurity risk in the context of a Canadian dental practice. Original article for Oral Health Journal.",
    view: "https://www.oralhealthgroup.com/features/cybersecurity-data-protection-in-dentistry-a-global-threat/",
    source: "https://www.oralhealthgroup.com/features/cybersecurity-data-protection-in-dentistry-a-global-threat/"
  }

];

export { ProjectCardData, ProjectCardData_2, ProjectCardData_3, ProjectCardData_4 };